import { render, staticRenderFns } from "./ProductDiscLdgReview.vue?vue&type=template&id=6ccdca8c&"
import script from "./ProductDiscLdgReview.vue?vue&type=script&lang=js&"
export * from "./ProductDiscLdgReview.vue?vue&type=script&lang=js&"
import style0 from "./ProductDiscLdgReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductDiscLdgReview.vue"
export default component.exports